import App from 'app/app.js';
import 'app/store/MessageStore.js';

function GlobalMessagesCtrl($scope, MessageStore) {
  $scope.getSystemMessages = function () {
    return MessageStore.getSystemMessages();
  };

  $scope.getFormMessages = function () {
    return MessageStore.getFormMessages();
  };
}

App.controller('GlobalMessagesCtrl', ['$scope', 'MessageStore', GlobalMessagesCtrl]);
